const getDefaultState = () => {
    return {
        thread: {},
        comment: {},
        reaction: {},
        attachment: {},
        user: {},
    }
}

const state = getDefaultState()

const getters = {
    // THREAD
    threads(state: any) {
        return state.thread
    },

    thread: (state: any) => (id: string) => {
        return state.thread[id]
    },

    // COMMENT
    comments(state: any) {
        return state.comment
    },

    comment: (state: any) => (id: string) => {
        return state.comment[id]
    },

    // REACTIONS
    reactions(state: any) {
        return state.reaction
    },

    reaction: (state: any) => (id: string) => {
        return state.reaction[id]
    },

    // ATTACHMENT
    commentAttachments(state: any) {
        return state.attachment
    },

    commentAttachment: (state: any) => (id: string) => {
        return state.attachment[id]
    },

    // USER
    commentUsers(state: any) {
        return state.user
    },

    commentUser: (state: any) => (id: string) => {
        return state.user[id]
    },
}

const mutations = {
    // THREAD
    threads(state: any, payload: any) {
        state.thread = payload
    },

    // COMMENT
    comments(state: any, payload: any) {
        state.comment = payload
    },

    // REACTION
    reactions(state: any, payload: any) {
        state.reaction = payload
    },

    // ATTACHMENT
    commentAttachments(state: any, payload: any) {
        state.attachment = payload
    },

    deleteCommentAttachment(state: any, payload: string) {
        delete state.attachment[payload]
    },

    // USER
    commentUsers(state: any, payload: any) {
        state.user = payload
    },

    //RESET
    resetComment(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
